export class TeamVersionsEnum {
    public static readonly V1 = 1;
    public static readonly V2 = 2;
}